import { IDetailsModal } from './interfaces';
import './DetailsModal.css';

export const DetailsModal = ({ modalProps }: IDetailsModal) => {
  return <p className="details-modal">{modalProps.content}</p>;
};
